import { qportalApi } from './qportal-api';
const getAllInvoices = (request) => {
    return qportalApi.get(`Invoice/GetInvoicesByMonthAndYear`, {
        params: { month: request.month, year: request.year }
    });
};
const getInvoicesByStatus = (invoiceStatus) => {
    return qportalApi.get(`Invoice/GetAllInvoicesByStatus/${invoiceStatus}`);
};
const AddUpdateInvoice = (request) => {
    return qportalApi.postForm(`Invoice/AddUpdateInvoice`, request);
};
const UpdateInvoiceStatus = (request) => {
    return qportalApi.postForm(`Invoice/UpdateInvoiceStatus`, request);
};
const getByInvoiceId = (request) => {
    return qportalApi.get(`Invoice/GetInvoiceById/${request}`);
};
const InvoiceApi = {
    getAllInvoices,
    AddUpdateInvoice,
    getInvoicesByStatus,
    getByInvoiceId,
    UpdateInvoiceStatus
};
export default InvoiceApi;
